define('models/EdenredDataModel',['underscore', 'backbone','LocalStorage', 'app',
    'ApiRequest',
    'ObjectModel',
    'formatPrice',
    'template!blocks/ui/check-switch'
],function(
    _,Backbone,LocalStorage,app,
    ApiRequest,
    ObjectModel,
    formatPrice,
    checkSwitchTemplate
){
    /*

    EdenredDataModel est un singleton
    Il gère l'authentification myEdenRed (Ticket Restaurant)

     */
    var model,
        EdenredWhere = {class_payment_module:'Edenred'},
        cartIgnoreExtraPrice = {ignoreExtraPrices:true},
        PENDING_STATE = 'pending',
        FETCHED_STATE = 'fetched',
        _PAYMENT_V2_;

    function getCartPriceTTC(withoutExtraPrice){
        var options = {}, cart = app.getCart();
        if(withoutExtraPrice){
            options = cartIgnoreExtraPrice;
        }
        return cart.getPriceTTC(options);
    }

    function getPrices(returnType){
        var cart = app.getCart(),
            paymentMode = getPaymentMode(),
            // l'exemple utilise en commentaire un panier total 19,75 avec 0,95 de frais de gestion

            totalPrice = getCartPriceTTC(true),
            // valeur du panier totale, sans les frais de gestion, sans cagnotte // 18,8

            extraPriceValue = app.getCart().getExtraPriceValue(),
            // valeur brute des frais de gestion // 0,95

            allow_fees = paymentMode ? paymentMode.getParam('allow_fees',0) : 0,
            extraPriceValueWithException = allow_fees ? 0 : extraPriceValue,
            // permet d'ignorer l'exception des frais de gestion (Belgique)

            cagnotte = cart.getCagnotte() || 0,
            // cagnotte utilisée // 1,95

            extraPriceLeftToPay = Math.max(0,extraPriceValueWithException-cagnotte),
            // frais de gestion restant à payer // 0

            extraPriceCagnotteUsed = extraPriceValueWithException-extraPriceLeftToPay,
            // frais de gestion utilisé par la cagnotte // 0,95

            cagnotteLeft = cagnotte - extraPriceCagnotteUsed,
            // restant de cagnotte // 1

            available = model.getAvailableAmount(),
            // crédit edenred // 19

            baseAvailable = Math.min(available,totalPrice),
            // maximum edenred sans notion de cagnotte // 18,8

            baseAltLeft = totalPrice - baseAvailable,
            // restant à payer de base sans notion de cagnotte // 0

            altLeftToPay = Math.max(0,baseAltLeft-cagnotteLeft),
            // total non edenred restant à payer sans cagnotte // 0

            altLeftCagnottedUsed = baseAltLeft-altLeftToPay,
            // 0

            edenredCagnotteUsed = cagnotte - extraPriceCagnotteUsed - altLeftCagnottedUsed,
            // cagnotte utilisable sur edenred // 1

            edenredToPay = baseAvailable - edenredCagnotteUsed,
            // payable via edenred 17,8

            totalLeftToPay = altLeftToPay + extraPriceLeftToPay;
            // total restant à payer // 0

            //totalCheck =
            //    edenredToPay + // 17,8
            //    edenredCagnotteUsed + // 1
            //    altLeftToPay + // 0
            //    altLeftCagnottedUsed + // 0
            //    extraPriceLeftToPay + // 0
            //    extraPriceCagnotteUsed;  // 0,95

        var r = 0;
        switch(returnType){
            case 'baseAvailable':
                r = baseAvailable;break;
            case 'altLeftCagnottedUsed':
                r = altLeftCagnottedUsed;break;
            case 'altLeftToPay':
                r = altLeftToPay;break;
            case 'edenredCagnotteUsed':
                r = edenredCagnotteUsed;break;
            case 'edenredToPay':
                r = edenredToPay;break;
            case 'totalLeftToPay':
                r = totalLeftToPay;break;
        }

        return parseFloat(Number(r).toFixed(2));

    }

    function getPaymentMethod(inContext){
        return (inContext?app.getCart():app).getPaymentMethods().findWhere(EdenredWhere);
    }

    function getPaymentGroup(){
        return app.getPaymentGroups().findWhere({location:1});
    }

    function getPaymentMode(inContext){
        return (inContext?app.getCart():app).getPaymentModes().findWhere({provider:'EdenredProvider'});
    }

    function getPM(inContext){
        return _PAYMENT_V2_ ? getPaymentMode(inContext) : getPaymentMethod(inContext);
    }

    function hasPM(inContext){
        return !!getPM(inContext) && (!_PAYMENT_V2_ || !!getPaymentGroup());
    }


    //
    var EdenredDataModel = ObjectModel.extend(LocalStorage).extend({
        name:'EdenredDataModel',
        route:'apiEdenredData',
        defaults:{
            sync:PENDING_STATE,
            checked:true, // default state
            availableAmount:0
        },
        initialize:function(){
            model = this; // singleton ref

            model.softFetch();
            model.set('sync',PENDING_STATE);
            model.listenTo(app,'hooksStarted',model.setup);
            model.on('change:checked',model.changeChecked);
            model.on('sync',model.updateStatus);

            window.edenred = model;
            //model.fetch();
        },
        changeChecked:function(){
            model.setLocalStorageItem();
        },
        updateStatus:function(){
            model.set('sync',FETCHED_STATE);
        },
        setup:function(){
            _PAYMENT_V2_ = app.c('_PAYMENT_V2_DESKTOP_','1')==='1';
            if(!hasPM()){
                model.set('sync',FETCHED_STATE);
                // si on a aucun moyen de paiement associé à EdenRed, il n'y a rien à faire
                return;
            }
            //
            var customer = app.getCustomer();
            model.listenTo(customer,'login logout',model.refresh);
            if(customer.isLogged()){
                model.refresh();
            }
        },
        hasPM:hasPM,
        getPM:getPM,
        isFetched:function(){
            return this.get('sync')===FETCHED_STATE;
        },
        displaySwitch:function(){
            // est-ce qu'on affiche le switch
            return !!getPM(app.c('_EDENRED_DISPLAY_IN_CONTEXT_','1') === '1');
            //var fetched = model.get('sync') === FETCHED_STATE;
            //return fetched && model.isAvailable() && !model.requireAuth();
        },
        isAvailable:function(){
            return !!getPM(true);
        },
        hasRestriction:function(){
            return hasPM(true) && getPM(true).hasProductRestriction();
        },
        isDisabled:function(){
            return model.hasRestriction() || (model.getAvailableAmount()<=0) || !hasPM(true) || app.getCart().isZeroTTC();
        },
        isChecked:function(){
            return model.get('checked');
        },
        isActive:function(){
            return hasPM(true) && model.isChecked() && !model.isDisabled();
        },
        isSelected:function(){
            return !model.isPending() && model.isActive() && model.isChecked();
        },
        isPending:function(){
            return model.get('sync') === PENDING_STATE;
        },
        isSelf:function(compare){
            var r = false,
                paymentMethod = getPM();
            if(hasPM() && !!compare){
                r = compare.id === paymentMethod.id;
            }
            return r;
        },
        getButtonDesc:function(){
            var paymentMode = getPaymentMode(),
                disabled = model.isDisabled(),
                tagName = 'label',
                desc_primary,
                desc_secondary = '',
                pict = false,
                classList = '',
                change_label = '',
                dark = true,
                warnings = [];
            if(model.get('sync') === PENDING_STATE){
                desc_primary = '<div class="circle-loader playing"></div>';
                desc_secondary = '';
                disabled = true;
            }else if(model.requireAuth()){
                desc_primary = getPM().getParam('select_btn_add_desc_primary');
                tagName = 'button';
                disabled = false;
                change_label = getPM().getParam('select_btn_add_change_label');
                classList = 'login-edenred';
            }else{
                dark = false;
                desc_primary = '<span data-cs-mask>'+model.get('login')+'</span>';
                desc_secondary = model.getCreditMessage();
                change_label = checkSwitchTemplate({
                    name:'edenred_switch',
                    disabled:model.isDisabled(),
                    checked:model.isChecked(),
                    classList:'dark'
                });
                pict = paymentMode.getPictureUrl();
                if(!hasPM(true)){
                    warnings.push( getPM().getParam('unavailable_store_message'));//app.t('Edenred est indisponible sur cette boutique'));
                }else if(model.hasRestriction()){
                    warnings.push(model.getPM().getRestrictionMessage());
                }else if(model.requireAltPM()){
                    warnings.push(getPM().getParam('require_alt_message'));
                    warnings.push(getPM().getParam('require_alt_details_message').replace('%s',model.formatAltDiffPrice()));
                }
            }
            return {
                disabled:disabled,
                tagName:tagName,
                desc_primary:desc_primary,
                desc_secondary:desc_secondary,
                change_label:change_label,
                class_list:classList,
                warnings: warnings,
                pict:pict,
                dark:dark
            }
        },
        refresh:function(){
            model.remoteFetch();
            model.set('sync',PENDING_STATE);
        },
        requireAuth:function(){
            return model.get('auth')!==true;
        },
        getAvailableAmount:function(){
            var a = model.get('availableAmount');
            return parseFloat(a);
        },
        formatAvailableAmount:function(){
            return formatPrice(model.getAvailableAmount());
        },
        getCreditMessage:function(){
            return getPM().getParam('display_credit_message').replace('%s',model.formatAvailableAmount());
        },
        getUsedAvailable:function(){
            // maximum utilisable, limité par le crédit, et le total panier sans frais de gestion
            return getPrices('edenredToPay');
        },
        getDifference:function(){
            return getPrices('totalLeftToPay');
        },
        getPrices:getPrices,
        requireAltPM:function(){
            return model.getDifference()>0;
        },
        formatAltDiffPrice:function(){
            // affiche le montant strict à payer, hors cagnotte
            return formatPrice(model.getDifference());
        },
        getName:function(){
            return getPM().get('name');
        },
        getAccountDesc:function(){
            // _ACCOUNT_TICKET_RESTAU_DESCRIPTION_AUTH_ or NOT
            return getPM().getParam('account_text_auth' + (model.requireAuth() ? 'not_auth':'auth')) || '';
        },
        getAccountLogout:function(){
            // _ACCOUNT_TICKET_RESTAU_DESCRIPTION_AUTH_ or NOT
            return getPM().getParam('account_logout') || '';
        },
        logout:function(){
            return ApiRequest('EdenredLogout')
        }
    });

    // used as singleton
    return new EdenredDataModel();
});

